var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorried(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    style: {
      enableBackground: "new 0 0 256 256"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#000000;stroke-width:12;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#000000;stroke-width:12;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 128,
    cy: 128,
    r: 117.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M71.1,176.1c9.5-22,31.4-37.4,56.9-37.4s47.4,15.4,56.9,37.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M62.3,99.7c2.5,4.4,7.2,7.3,12.6,7.3c5,0,9.5-2.6,12.1-6.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M193.7,99.7c-2.5,4.4-7.2,7.3-12.6,7.3c-5,0-9.5-2.6-12.1-6.4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorried);
export default __webpack_public_path__ + "static/media/Worried.d7e728280e5ba920d126cb273f878a16.svg";
export { ForwardRef as ReactComponent };